import { env } from '@/shared/config';

import { createApiClient } from './apiClient';

const workflowsApi = createApiClient({
  baseURL: env.baseApiUrl,
});

export const apiServices = { workflowsApi };
